export default __webpack_public_path__ + "static/media/portfolio-137.122e719b.jpg";